import { Link } from 'react-router-dom';
import { BookOpen, Clock, ArrowRight } from 'lucide-react';
import { ARTICLES } from '../data/articles';

export default function Blog() {
  return (
    <div className="max-w-5xl mx-auto">
      <section className="text-center py-12">
        <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 rounded-full px-4 py-1.5 text-sm font-medium mb-6">
          <BookOpen className="w-4 h-4" />
          Tips & Guides
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Never Forget Anything — A Guide</h1>
        <p className="text-gray-500 max-w-2xl mx-auto text-lg">
          Practical, no-nonsense articles on reminders, memory, money, and staying on top of the dates that matter.
        </p>
      </section>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pb-16">
        {ARTICLES.map(article => (
          <Link
            key={article.slug}
            to={`/blog/${article.slug}`}
            className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 hover:shadow-md transition-shadow flex flex-col"
          >
            <span className="inline-block bg-blue-50 text-blue-600 text-xs font-medium px-2.5 py-1 rounded-full w-fit mb-3">
              {article.category}
            </span>
            <h2 className="font-semibold text-gray-900 text-lg leading-snug mb-2">{article.title}</h2>
            <p className="text-sm text-gray-500 leading-relaxed flex-1">{article.excerpt}</p>
            <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-50">
              <span className="text-xs text-gray-400 flex items-center gap-1">
                <Clock className="w-3.5 h-3.5" /> {article.readTime}
              </span>
              <span className="text-sm font-medium text-blue-600 flex items-center gap-1">
                Read <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
